"use strict";
// BASEline main js file
requirejs.config({
    baseUrl: "/assets/javascripts",
    paths: {
        cesium: "https://cesium.com/downloads/cesiumjs/releases/1.95/Build/Cesium/Cesium",
        d3: "./d3.min"
    }
});
/* tslint:disable:no-var-requires */
require([
    "auth2",
    "contact",
    "metric",
    "notifications",
    "pages/laser-page",
    // "pages/map", // don't pre-load cesium
    "pages/track-page",
    // "pages/track-3d", // don't pre-load cesium
    "pages/track-speed-page",
    "pages/user-page",
    "pages/user-settings",
    "studio/studio",
    "util/log"
]);
//# sourceMappingURL=/assets/javascripts/main.js.map;
define("main", function(){});

